import { type ResponseResolver, delay, HttpResponse } from 'msw';
import type { PostRankingUserIdBody } from '~/api/generated/model';

const statusCode = Number(
  new URLSearchParams(window.location.search).get('statusCode'),
);

export const postUserScore: ResponseResolver<
  Record<string, unknown>,
  PostRankingUserIdBody
> = async ({ request }) => {
  await delay('real');

  const body = await request.json();

  const mock = (): PostRankingUserIdBody => {
    return {
      ...body,
    };
  };

  if (!statusCode) {
    return new HttpResponse(JSON.stringify(mock()), { status: 200 });
  }
  return new HttpResponse(
    JSON.stringify({
      type: 'Error',
      path: '/path/to/api',
      message: 'Unauthorized',
    }),
    { status: statusCode },
  );
};

export const postUserName: ResponseResolver<
  Record<string, unknown>,
  PostRankingUserIdBody
> = async ({ request }) => {
  await delay('real');

  const body = await request.json();

  const mock = (): PostRankingUserIdBody => {
    return {
      ...body,
    };
  };

  if (!statusCode) {
    return new HttpResponse(JSON.stringify(mock()), { status: 200 });
  }
  return new HttpResponse(
    JSON.stringify({
      type: 'Error',
      path: '/path/to/api',
      message: 'Unauthorized',
    }),
    { status: statusCode },
  );
};
